import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function Placeholder({ title, subtitle, description }) {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-cream flex flex-col" data-testid={`placeholder-${title}`}>
      <header className="flex items-center gap-3 px-5 pt-5 pb-3">
        <button
          onClick={() => nav("/hall")}
          data-testid="back-to-hall-button"
          className="p-2 -ml-2 rounded-full hover:bg-sand/50"
          aria-label="В главный зал"
        >
          <ChevronLeft className="w-5 h-5 text-espresso" />
        </button>
        <div>
          <div className="text-[10px] uppercase tracking-[0.28em] text-muted-foreground">
            Anokina Studio
          </div>
          <h1 className="font-serif text-2xl text-espresso -mt-0.5">{title}</h1>
        </div>
      </header>

      <div className="flex-1 flex items-center justify-center px-6 py-10">
        <div className="max-w-md text-center rounded-3xl bg-white border hairline px-8 py-12">
          <div className="chip bg-sand/60 text-espresso inline-block mb-4">{subtitle}</div>
          <h2 className="font-serif text-3xl text-espresso leading-tight">Скоро</h2>
          <p className="text-sm text-muted-foreground mt-3 leading-relaxed">
            {description ||
              "Это пространство откроется в следующих спринтах. Мы уже готовим для вас нужные инструменты."}
          </p>
        </div>
      </div>
    </div>
  );
}
